import { DiffSummary } from '../data-qa-types';

// The review bar's one-line account of what changed since the section's last review.
export const changeSummary = (summary: DiffSummary, isColdStart: boolean): string => {
  if (isColdStart) return 'First review';
  const parts = [
    summary.changed > 0 && `${summary.changed} changed`,
    summary.new > 0 && `${summary.new} new`,
    summary.removed > 0 && `${summary.removed} removed`
  ].filter(Boolean);
  return parts.length === 0
    ? 'No changes since last review'
    : `${parts.join(' · ')} since last review`;
};
